import UserManagement from 'containers/UserManagement'
import React from 'react'

const index = () => {
  return <UserManagement />
}

export default index
